module.exports = __webpack_public_path__ + "img/books_thankyou.857dcdad.png";